class MapStores extends HTMLElement {
  constructor() {
    super();
    this.mapStores = this.querySelector("#mapStores");
    this.countrySelector = this.querySelector("#search_map-country");
    this.citySelector = this.querySelector("#search_map");
    this.searchButton = this.querySelector("#search-button");
    this.resultFilters = this.querySelector("#detail-result-filter-map-stores");
    this.filterMapStores = this.querySelector("#filter-map-stores");
    this.shopLocationsMapOptions = shopLocationsMapOptions;
    this.map = null;
    this.geocode = null;

    this.shopLocationsMap = shopLocationsMapList;

    document.addEventListener("DOMContentLoaded", () => {
      this.initMap();
      this.geocoder = new google.maps.Geocoder();
    });

    this.countrySelector.addEventListener(
      "change",
      this.onChangeCountry.bind(this)
    );

    this.searchButton.addEventListener(
      "click",
      this.apply_filter_map.bind(this)
    );
  }

  initMap() {
    this.map = new google.maps.Map(this.mapStores, {
      zoom: 4,
      styles: [
        {
          featureType: "administrative",
          elementType: "all",
          stylers: [
            {
              saturation: "-100",
            },
          ],
        },
        {
          featureType: "administrative.province",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "landscape",
          elementType: "all",
          stylers: [
            {
              saturation: -100,
            },
            {
              lightness: 65,
            },
            {
              visibility: "on",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "all",
          stylers: [
            {
              saturation: -100,
            },
            {
              lightness: "50",
            },
            {
              visibility: "simplified",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "all",
          stylers: [
            {
              saturation: "-100",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "all",
          stylers: [
            {
              visibility: "simplified",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "all",
          stylers: [
            {
              lightness: "30",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "all",
          stylers: [
            {
              lightness: "40",
            },
          ],
        },
        {
          featureType: "transit",
          elementType: "all",
          stylers: [
            {
              saturation: -100,
            },
            {
              visibility: "simplified",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            {
              hue: "#ffff00",
            },
            {
              lightness: -25,
            },
            {
              saturation: -97,
            },
          ],
        },
        {
          featureType: "water",
          elementType: "labels",
          stylers: [
            {
              lightness: -25,
            },
            {
              saturation: -100,
            },
          ],
        },
      ],
      center: { lat: 18.362674, lng: -83.727157 },
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    });

    var infowindow = new google.maps.InfoWindow();
    let marker;
    this.shopLocationsMap.map((location, index) => {
      marker = new google.maps.Marker({
        position: new google.maps.LatLng(location.lat, location.lng),
        map: this.map,
        info: location,
        icon: img_ico_map,
      });

      allMarkers.push(marker);

      let info_html = `
       <h5><strong>${location.Almacen}</strong></h5>
       <p>Address: ${location.Direccion}</p>
       <p>Phone: <a href="tel:${location.Telefono}">${location.Telefono}</a></p>
       <p>Monday to Friday: ${location['Lunes a Viernes']}</p>
       <p>Saturday: ${location['sabados']}</p>
       <p>Holidays: ${location['Festivos']}</p>
      `;

      google.maps.event.addListener(
        marker,
        "click",
        (function (marker, i) {
          return function () {
            infowindow.setContent(info_html);
            infowindow.open(this.map, marker);
          };
        })(marker, index)
      );
    });

    print_filter_map();
  }

  onChangeCountry(event) {
    this.citySelector.innerHTML = build_cities_for_country(event.target.value);
  }

  build_cities_for_country(country = "") {
    let _html = `
    <option value="" disabled selected>City</option>
    ${shopLocationsMapOptions
      .map((element) => {
        element.ciudades.map((city) => {
          if (country == element.pais || !country) {
            return `<option value="${city}">${city}</option>`;
          }
        });
      })
      .join("")}
    `;

    return _html;
  }

  center_map(address) {
    const map = this.map;
    this.geocoder.geocode({ address: address }, function (results, status) {
      if (status === "OK") {
        map.setCenter(results[0].geometry.location);
        map.setZoom(6);
      }
    });
  }

  apply_filter_map(event) {
    const param = this.citySelector.value;

    const _info = [];
    allMarkers.map((marker) => {
      let validation = marker.info.Ciudad === param;
      marker.setVisible(validation);

      if (validation) {
        _info.push(marker.info);
      }
    });

    let _html = `
    <ul class="list_location_shop">
    ${_info
      .map(
        (i) =>
          `<li>
        <span>${i.Almacen}</span>
        <span>${i.Direccion}</span>
        <span><a href="tel:${i.Telefono}">${i.Telefono}</a></span>
      </li>`
      )
      .join("")}
    </ul>
    `;

    this.resultFilters.innerHTML = _html;
    this.center_map(param);
  }

  print_filter_map() {
    let _html = `
      <h3>Find Store</h3>
        <div>
          <div class="option">
            <select name="search-country" id="search_map-country">
              <option value="" disabled selected>Country</option>
            ${shopLocationsMapOptions
              .map(
                (elem) => `<option value="${elem.pais}">${elem.pais}</option>`
              )
              .join("")}
            </select>
          </div>
          <div class="option">
            <select name="search" id="search_map">
              ${build_cities_for_country(false)}
            </select>
          </div>
        </div>
      <button type="button" id="search-button">SEARCH</button>
    `;

    this.filterMapStores.innerHTML = _html;
  }
}

customElements.define("map-stores", MapStores);
